/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import List from '@ckeditor/ckeditor5-list/src/list';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { icons } from 'ckeditor5/src/core';
export default class ImageBank extends Plugin {
	init() {
		const editor = this.editor;
// @ts-ignore
		editor.ui.componentFactory.add( 'imagebank', () => {
			// The button will be an instance of ButtonView.
			const button = new ButtonView();

			button.set( {
				label: '',
				icon:icons.image,
				withText: true
			} );

			//Execute a callback function when the button is clicked
			button.on('execute', () => {
				const model = this.editor.model;
				const now = new Date().getTime();
				// @ts-ignore
				openMaterialCenter(now,model,this.editor)
				// layer.open({
				// 	type: 2,
				// 	title: '图片上传',
				// 	skin: 'layui-layer-picture-bank', //自定义样式
				// 	area: ['80%', '80%'],
				// 	content: '/admin/image_bank/popImage?pic_bank_limit_num=20&type=editor',
				// 	//content: '/index.php/admin/image_bank/popImage?pic_bank_limit_num=20',
				// 	btn: ['确定', '取消'],
				// 	yes: function (index, layero) {
				// 		var product_name=  $('#product_name').val();//获取输入框元素
				// 		var blog_name = $('#title').val();//获取博客标题
				// 		var body = layer.getChildFrame('body', index);
				// 		var selectedLi = body.find(".img-list").find("li.selected");
				// 		let source=[]
				// 		selectedLi.each(function (index, item) {
				// 			var imageData = $(item).find("img").attr("src");
				// 			// 创建img标签
				// 			// var image = editor.document.createElement('img');
				// 			// 给img标签设置class类
				// 			// image.setAttribute('class', 'insert-image');
				// 			 var title;
				//
				// 			  if((product_name != null && product_name != "") || (blog_name != null && blog_name != "")) {
				// 			  	product_name = product_name.replace(/['"]+/g, "")
				//
				// 			  	if(product_name){
				// 			  		title = product_name;
				// 			  	} else {
				// 			  		title = blog_name;
				// 			  	}
				// 			  }
				// 			source.push({ src: imageData, alt:title||'' ,title:title||''})
				//
				// 		})
				// 		editor.model.change( writer => {
				// 			editor.execute('insertImage', {
				// 				source:source
				// 			} );
				// 		} );
				// 		layer.close(index);
				// 	},
				// });

			} );

			return button;
		} );
	}
}

